import { useEffect } from "react";

export const useBmiCalculation = (form) => {
  const watchedWeight = form.watch("maternalWeightKg");
  const watchedHeight = form.watch("maternalHeightCm");

  useEffect(() => {
    const weight = parseFloat(watchedWeight);
    const heightCm = parseFloat(watchedHeight);
    if (weight > 0 && heightCm > 0) {
      const heightM = heightCm / 100;
      const bmi = parseFloat((weight / (heightM * heightM)).toFixed(1));
      form.setValue("bmi", String(bmi));
    }
  }, [watchedWeight, watchedHeight, form]);
};
